<app-state-section content [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
  <section class="madar--v2">
  <mat-card class="card--bordered">
    <mat-card-header class="card-header--divided">
      <div class="flex justify-space-between row">
        <span class="weight-medium h6 m-0 text-900">{{ "Users.GeneralInformation" | translate }}</span>
        <div *ngIf="allowEdit">
          <button
            *grantAccess="(isProfile ? rolesConstants.PROFILE_EDIT : rolesConstants.USER_EDIT); onlyIf viewMode"
            type="button"
            mat-raised-button
            (click)="viewMode = false"
          >
            <mat-icon>edit</mat-icon>
            <span>{{ "Buttons.Edit" | translate}}</span>
          </button>
          <button
            *ngIf="isProfile && viewMode &&  (rolesConstants.PROFILE_EDIT | userRoleChecker)"
            class="ml-2"
            type="button"
            mat-raised-button
            (click)="onResetPassword()"
          >
            <mat-icon>lock</mat-icon>
            <span>{{ "Buttons.ResetPassword" | translate}}</span>
          </button>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content>
      <!-- View User -->
      <ng-container *ngIf="viewMode">
        <div class="profile-img" *ngIf="false">
          <img src="assets/images/madar-logo.svg" />
        </div>

        <div class="user-info flex">
          <div *ngIf="selectedUser.name" class="sm-top-margin">
            <span class="label">{{ "Inputs.Name" | translate }}</span>
            <p class="data">{{ selectedUser.name }}</p>
          </div>

          <div *ngIf="selectedUser.mobileNumber" class="sm-top-margin">
            <span class="label">{{ "Inputs.MobileNumber" | translate }}</span>
            <p class="data" [class.rtl]="layoutService.websiteDirection$.value === 'rtl'">{{ selectedUser.mobileNumber }}</p>
          </div>

          <div class="sm-top-margin">
            <span class="label">{{ "Inputs.EmailAddress" | translate }}</span>
            <p class="data">{{ selectedUser.email || "______" }}</p>
          </div>

          <div>
            <span class="label">{{ "Inputs.Country" | translate }}</span>
            <p class="data">{{ selectedUser.country?.name || "______" }}</p>
          </div>

          <div *ngIf="selectedUser.roles">
            <span class="label">{{"Inputs.Privilege" | translate}}</span>
            <div class="flex column">
              <ng-container *ngFor="let role of selectedUser.roles; let i = index">
                <div *ngIf="i < 3" class="role">
                  <p class="roles-limited-text data">{{ 'Enum.Roles.' + role.name | translate}}</p>
                  <p *ngIf="i == 2 && selectedUser.roles.length - 3 > 0" class="roles-count data">+ {{ selectedUser.roles.length - 3 }}</p>
                </div>
              </ng-container>
            </div>
          </div>

          <div>
            <span class="label">{{ "Inputs.Status" | translate }}</span>
            <p class="data">{{ ("Enum.UserStatus." + selectedUser.status | translate) || "_____" }}</p>
          </div>

          <div *grantAccess="rolesConstants.CUSTOMER_ADD_EDIT_USER; onlyIf: userType !== UserType.FLEET">
            <span class="label">{{ "Inputs.ShippingType" | translate }}</span>
            <p class="data">{{ ("Enum.ShippingType." + selectedUser.shippingType | translate) || "_____" }}</p>
          </div>
        </div>
      </ng-container>

      <!-- Update User -->
      <ng-container *ngIf="!viewMode">
        <app-user-form
          [user]="selectedUser"
          [userType]="userType"
          [id]="userId"
          [isProfile]="isProfile"
          [action]="'update'"
          (update)="handleUpdateEvent($event)"
          (close)="viewMode = true"
        ></app-user-form>
      </ng-container>
    </mat-card-content>
  </mat-card>
  </section>

  <app-user-params
    class="d-block my-4"
    *grantAccess="rolesConstants.USER_PARAMS_VIEW;"
    [userId]="selectedUser.id"
  ></app-user-params>

  <!-- will be removed after move it to account details -->
  <!--  <mat-card class="setting-card" *ngIf="false">-->
  <!--    <mat-card-content class="card-content">-->
  <!--      <mat-card-header class="info-card-header flex row">-->
  <!--        <mat-card-title class="title">{{ "Users.AccountSettings" | translate }}</mat-card-title>-->

  <!--        <div class="flex row edit" (click)="viewMode = false">-->
  <!--          <span class="text-primary"><app-icon type="Image" name="assets/images/edit.svg"></app-icon></span>-->
  <!--          <span>{{ "Buttons.Edit" | translate}}</span>-->
  <!--        </div>-->
  <!--      </mat-card-header>-->

  <!--      <mat-divider></mat-divider>-->

  <!--      <mat-card-content>-->
  <!--        <ng-container>-->
  <!--          <div class="user-info flex">-->
  <!--            <div class="language">-->
  <!--              <span class="label">{{ "Inputs.Language" | translate }}</span>-->
  <!--              <p class="data">{{ selectedUser.name }}</p>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--          <div class="change-password">{{ "Users.ChangeMyPassword" | translate }}</div>-->
  <!--        </ng-container>-->
  <!--      </mat-card-content>-->
  <!--    </mat-card-content>-->
  <!--  </mat-card>-->

  <app-modal #passwordModal [title]="'Users.ChangeMyPassword' | translate" [maxWidth]="700" [padding]="20" [textColor]="'var(--color-dark)'">
    <form [formGroup]="passwordForm" *ngIf="passwordForm" (submit)="updatePassword()">
      <div>
        <mat-label class="d-block w-100">{{'Inputs.OldPassword'|translate}}</mat-label>
        <mat-form-field class="d-block w-100" appearance="outline">
          <input [type]="showPassword ? 'text' : 'password'" matInput formControlName="password" />
          <button type="button" mat-icon-button matSuffix (mousedown)="showPassword = true" (mouseup)="showPassword = false">
            <mat-icon *ngIf="showPassword">visibility</mat-icon>
            <mat-icon *ngIf="!showPassword">visibility_off</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div>
        <mat-label class="d-block w-100">{{'Inputs.Password'|translate}}</mat-label>
        <mat-form-field class="d-block w-100" appearance="outline">
          <input [type]="showNewPassword ? 'text' : 'password'" matInput formControlName="newPassword" />
          <button type="button" mat-icon-button matSuffix (mousedown)="showNewPassword = true" (mouseup)="showNewPassword = false">
            <mat-icon *ngIf="showNewPassword">visibility</mat-icon>
            <mat-icon *ngIf="!showNewPassword">visibility_off</mat-icon>
          </button>
          <mat-error *ngIf="passwordForm.invalid && passwordForm.get('newPassword').touched  && passwordForm.get('newPassword').hasError('required')">
            {{ "ErrorMessages.Required" | translate }}
          </mat-error>
          <mat-error
            *ngIf="passwordForm.invalid && passwordForm.get('newPassword').touched && passwordForm.get('newPassword').hasError('invalidPassword')"
          >
            {{ "ErrorMessages.InvalidPassword" | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <app-row>
        <app-col>
          <button mat-raised-button type="button" class="btn-secondary" (click)="handleCancelPassword()">{{'Buttons.Cancel' | translate}}</button>
        </app-col>

        <app-col cols="auto">
          <button mat-raised-button type="submit" color="primary" [disabled]="passwordForm.invalid">{{'Buttons.Save' | translate}}</button>
        </app-col>
      </app-row>
    </form>
  </app-modal>
</app-state-section>
